<template>
    <div class="text-white ds-text-sm">
        {{formattedTimeRemaining}}
    </div>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from '@/utils/namespaced-mappings'

    export default {
        props: {
            namespace: { type: String, required: true },
        },

        computed: {
            ...mapGetters(['absoluteTime', 'totalOverallTime']),
            
            timeRemaining() {
                return this.totalOverallTime - this.absoluteTime
            },

            formattedTimeRemaining() {
                return this.format(this.timeRemaining)
            },
        },

        methods: {
            format(milliseconds) {
                const oneHour = 60 * 60 * 1000
                const format = this.totalOverallTime > oneHour
                    ? '*hh:mm:ss'
                    : '*mm:ss'

                return moment.duration(milliseconds, 'milliseconds').format(format)
            }
        }
    }
</script>